module.exports = __webpack_public_path__ + "static/media/sk.91f544fe.svg";